import { NgModule } from '@angular/core';

import { DevFlagsDataModule } from '@recruitee/dev-flags-data';

import { DevFlagDirective } from './directives/dev-flags.directive';

@NgModule({
  declarations: [DevFlagDirective],
  imports: [DevFlagsDataModule],
  exports: [DevFlagDirective],
})
export class DevFlagsModule {}
